import { useFeature } from 'src/abTesting';
import { CVR_HOMEPAGE_EXIT_INTENT } from 'src/abTesting/features';

export function useHomepageExitIntent() {
  const { treatment } = useFeature(CVR_HOMEPAGE_EXIT_INTENT);
  return { shouldShowExitIntent: treatment === 'on' };
}
